export default __webpack_public_path__ + "static/media/z.99e5b41b.svg";